import { ChangeDetectorRef, ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { filter } from 'rxjs/operators';
import { BreadcrumbService } from "@bioconnect-ui/breadcrumb-service";

@Component({
  standalone: true,
  imports: [
    BreadcrumbModule,
    CommonModule,
  ],
  selector: 'bioconnect-ui-breadcrumb-nav',
  templateUrl: './breadcrumb-nav.component.html',
  providers: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class BreadcrumbNavComponent implements OnInit {
  @Input() page = '';
  @Input() context: any = {};
  showBreadcrumbNav = true;
  home: MenuItem = {
    icon: "pi pi-home",
    routerLink: '/portal-home'
  }
  items: MenuItem[] = [];
  constructor(private activatedRoute: ActivatedRoute,
              private route: Router,
              private breadcrumbService: BreadcrumbService,
              private cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    // re-calc breadcrumb labels when a custom one is created
    this.breadcrumbService.breadcrumbs$
      .subscribe(() => {
        this.items = this.createBreadcrumbs(this.activatedRoute.root);
        this.cdr.markForCheck();
      });
    // calc breadcrumb labels when navigating to a page
    this.route.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.items = this.createBreadcrumbs(this.activatedRoute.root);
        this.cdr.markForCheck();
      });
  }

  private createBreadcrumbs(route: ActivatedRoute, url = '', breadcrumbs: MenuItem[] = []): MenuItem[] {
    const children: ActivatedRoute[] = route.children;
    if (children.length === 0) {
      return breadcrumbs;
    }
    // go through nested child routes and build a breadcrumb label and link for each nested route
    for (const child of children) {
      const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');
      if (routeURL !== '') {
        url += `/${routeURL}`;
        breadcrumbs = breadcrumbs.concat(this.breadcrumbService.getBreadcrumbs(url, child));
      }
      return this.createBreadcrumbs(child, url, breadcrumbs);
    }
    return breadcrumbs;
 }

}
